export default {
	props: {
		maxlength: {
			type: [Number, String],
			default: null
		},
		rows: {
			type: Number,
			default: 4
		}
	},
	data() {
		return {
			textValue: '',
			textDefaultValue: ''
		};
	},
	methods: {
		textChange(e) {
			const parsedValue = this.parseValue(e.target.value);
			this.$emit('input', parsedValue);
		},
		textParseDefaultValue() {
			if (this.defaultValue !== null) return this.defaultValue.toString();
			return this.textDefaultValue;
		}
	}
};
